export default "__VITE_ASSET__qp8eZPnW__"